import styled, {
  createGlobalStyle,
} from 'styled-components/macro';
import React from 'react';
import Loading from '../common/components/Loading';
import {
  theme,
} from '../common/utilsClient/cssHelpers';
import {
  getBranding,
} from '../utils/branding';
import Logo from '../components/Logo';

const branding = getBranding();

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${theme('color.background')} !important;
  }
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: ${theme('space.3')}; */
  padding: 1.5rem;
`;

const AppSkeleton = () => {
  return (
    <>
      <GlobalStyle />
      <StyledWrapper>
        <Logo branding={branding} />
        <Loading />
      </StyledWrapper>
    </>
  );
};

export default AppSkeleton;
